const Mutations = Object.freeze({
	SET_ACTIVITY_ITEMS: 'activityBuilder/activityItem/SET_ACTIVITY_ITEMS',
	REMOVE_ACTIVITY_ITEM: 'activityBuilder/activityItem/REMOVE_ACTIVITY_ITEM',
	SET_CONDITION_FIELDS_LIST:
		'activityBuilder/activityItem/SET_CONDITION_FIELDS_LIST',
	SET_STATIC_FIELDS: 'activityBuilder/activityItem/SET_STATIC_FIELDS',
	SET_LOADING: 'activityBuilder/activityItem/SET_LOADING',
});

export const Actions = Object.freeze({
	CLEAR: 'activityBuilder/activityItem/CLEAR',
	LOAD_ACTIVITY_ITEMS: 'activityBuilder/activityItem/LOAD_ACTIVITY_ITEMS',
	LOAD_FIELDS: 'activityBuilder/activityItem/LOAD_FIELDS',
	DELETE: 'activityBuilder/activityItem/DELETE',
});

export const Getters = Object.freeze({
	ACTIVITY_ITEMS: 'activityBuilder/activityItem/ACTIVITY_ITEMS',
	CONDITION_FIELDS_LIST: 'activityBuilder/activityItem/CONDITION_FIELDS_LIST',
	STATIC_FIELDS: 'activityBuilder/activityItem/STATIC_FIELDS',
	LOADING: 'activityBuilder/activityItem/LOADING',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/activityDataService';
import activityItemModal from './activityItemModal';

export default {
	state: {
		activityItems: [],
		conditionFieldsList: [],
		staticFields: [],
		loading: false,
	},
	modules: {
		activityItemModal,
	},
	mutations: {
		[Mutations.SET_ACTIVITY_ITEMS](state, items) {
			state.activityItems = items;
		},
		[Mutations.SET_STATIC_FIELDS](state, items) {
			state.staticFields = items;
		},
		[Mutations.SET_CONDITION_FIELDS_LIST](state, items) {
			state.conditionFieldsList = items;
		},
		[Mutations.REMOVE_ACTIVITY_ITEM](state, id) {
			let index = state.activityItems.findIndex((x) => x.Id == id);
			state.activityItems.splice(index, 1);
		},
		[Mutations.SET_LOADING](state, item) {
			state.loading = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			commit(Mutations.SET_ACTIVITY_ITEMS, []);
		},
		[Actions.LOAD_ACTIVITY_ITEMS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.getActivityItems(id)
					.then((resp) => {
						commit(Mutations.SET_ACTIVITY_ITEMS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_FIELDS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				Promise.all([
					dataService
						.getGroupByConditionFieldList(id)
						.then((resp) => {
							commit(
								Mutations.SET_CONDITION_FIELDS_LIST,
								resp.data
							);
						}),
					dataService.getStaticFieldsByActivityId(id).then((resp) => {
						commit(Mutations.SET_STATIC_FIELDS, resp.data);
					}),
				])
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteActivityItem(id)
					.then(() => {
						commit(Mutations.REMOVE_ACTIVITY_ITEM, id);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.ACTIVITY_ITEMS]: (state) => {
			return JSON.parse(JSON.stringify(state.activityItems));
		},
		[Getters.CONDITION_FIELDS_LIST]: (state) => {
			return JSON.parse(JSON.stringify(state.conditionFieldsList));
		},
		[Getters.STATIC_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.staticFields));
		},
		[Getters.LOADING]: (state) => {
			return state.loading;
		},
	},
};
